import { useState, useEffect } from 'react';
import { Container, Card, Form, Button, Alert } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { register } from '../../api/authApi';
import { useAuth } from '../../context/AuthContext';

const Register = () => {
  const [form, setForm] = useState({ name: '', email: '', mobile: '', password: '', referralCode: '' });
  const [confirmPassword, setConfirmPassword] = useState('');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get('referral_code');
    if (code) setForm((prev) => ({ ...prev, referralCode: code }));
  }, []);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { loginUser } = useAuth();
  const navigate = useNavigate();

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (form.password !== confirmPassword) {
      return setError('Passwords do not match');
    }
    setLoading(true);
    try {
      const res = await register(form);
      loginUser(res.data.token, res.data.user);
      navigate('/dashboard');
    } catch (err) {
      setError(err.response?.data?.message || 'Registration failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container className="d-flex justify-content-center align-items-center" style={{ minHeight: '80vh' }}>
      <Card style={{ width: '400px' }} className="p-4 shadow">
        <h4 className="text-center mb-4">Create Account</h4>
        {error && <Alert variant="danger">{error}</Alert>}
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>Name <span className="text-danger">*</span></Form.Label>
            <Form.Control type="text" name="name" value={form.name} onChange={handleChange} required />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Email <span className="text-danger">*</span></Form.Label>
            <Form.Control type="email" name="email" value={form.email} onChange={handleChange} required />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Mobile Number <span className="text-danger">*</span></Form.Label>
            <Form.Control type="tel" name="mobile" value={form.mobile} onChange={handleChange} pattern="[0-9]{10,15}" placeholder="e.g. 9876543210" required />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Password <span className="text-danger">*</span></Form.Label>
            <Form.Control type="password" name="password" value={form.password} onChange={handleChange} minLength={6} required />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Re-enter Password <span className="text-danger">*</span></Form.Label>
            <Form.Control type="password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} required />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Referral Code <span className="text-danger">*</span></Form.Label>
            <Form.Control type="text" name="referralCode" value={form.referralCode} onChange={handleChange} placeholder="9-digit referral code" maxLength={9} required />
          </Form.Group>
          <Button type="submit" className="w-100" disabled={loading}>
            {loading ? 'Creating account...' : 'Register'}
          </Button>
        </Form>
        <div className="text-center mt-3">
          <small>Already have an account? <Link to="/login">Sign in</Link></small>
        </div>
      </Card>
    </Container>
  );
};

export default Register;
